export default 'https://tme.understood.org/assets/apple.c5c3b4e8.lottie'